import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/es/integration/react';
import { store, persistor } from './Reducers/store';
import AnalyticsRoutesTracker from './Components/AnalyticsRoutesTracker';
import SiteContainer from './Components/SiteContainer';
import ContentContainer from './Components/ContentContainer';
import HomePage from './Pages/HomePage';
import EventInfoPage from './Pages/EventInfoPage';
import EventInfoOverviewPage from './Pages/EventInfoOverviewPage';
import EventInfoItineraryPage from './Pages/EventInfoItineraryPage';
import EventInfoVenueInfoPage from './Pages/EventInfoVenueInfoPage';
import EventInfoAttendeesPage from './Pages/EventInfoAttendeesPage';

class App extends Component {
  state = {
    isLoading: false,
  };

  componentDidMount = () => {
  };

  render() {
    return (
      <PersistGate persistor={persistor}>
        <Provider store={store}>
          <SiteContainer>
              <Router basename="/lks/app" history={this.history}>
              <AnalyticsRoutesTracker />
                <ContentContainer>
                    <Route path="/" exact component={HomePage} />
                    <Route path="/event-info" exact component={EventInfoPage} />
                    <Route path="/event-info/overview/" exact component={EventInfoOverviewPage} />
                    <Route path="/event-info/itinerary/" exact component={EventInfoItineraryPage} />
                    <Route path="/event-info/venue-info/" exact component={EventInfoVenueInfoPage} />
                    <Route path="/event-info/attendees/" exact component={EventInfoAttendeesPage} />
                    <Route path="/event-info/attendees/general/" exact component={EventInfoAttendeesPage} />
                    <Route path="/event-info/attendees/acic/" exact component={EventInfoAttendeesPage} />
                </ContentContainer>
              </Router>
            
          </SiteContainer>
          </Provider>
      </PersistGate>
    );
  }
}

export default App;